module.exports = __webpack_public_path__ + "static/media/casais.54e70115.webp";